import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng';

@Component({
  selector: 'route-icon',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './route-icon.component.html',
  styleUrls: ['./route-icon.component.css'],
})
export class RouteIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
